export default __webpack_public_path__ + "static/media/info1.a15dc7d4.png";